import { render, staticRenderFns } from "./ColorTile.vue?vue&type=template&id=aeff8934&scoped=true&"
import script from "./ColorTile.vue?vue&type=script&lang=js&"
export * from "./ColorTile.vue?vue&type=script&lang=js&"
import style0 from "./ColorTile.vue?vue&type=style&index=0&id=aeff8934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeff8934",
  null
  
)

export default component.exports